import React from 'react';
import DisplayName from './DisplayName';
import Checkbox from '@material-ui/core/Checkbox';
import ConstValues from 'utils/const';
import AdminWelcomeEmailActions from 'actions/admin/AdminWelcomeEmailActions';

const {adminWelcomeEmailTypes: TYPES} = ConstValues;

export default class UserInviteTable extends React.PureComponent {
  render() {
    const rows = this.props.users.map((user, i) => {
      return (
        <tr key={user.id}>
          <td>
            <DisplayName user={user} />
          </td>
          <td>{user.email}</td>
          <td>
            <Checkbox
              onChange={() => AdminWelcomeEmailActions.selectItem(TYPES.invite, user.id)}
              checked={this.props.selected.getIn([TYPES.invite, user.id])}
            />
          </td>
        </tr>
      );
    });
    return (
      <table className="user-list-table invite-table">
        <thead>
          <tr>
            <th>Rep</th>
            <th>E-mail</th>
            <th>Invite</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    );
  }
}
